import angular from 'angular';

import angularTranslate, {provideTranslations} from 'acng/core/service/angular-translate';

import onswAmateurContext, {contextComponent} from './widgets/context';
import './widgets/otm-shuffle';
import './widgets/list-small';
import featureName from './config/feature.js';
import {AmateurTile} from './tiles/AmateurTile.js';
import './element/index.js';
import './attribute/index.js';
import './attribute/partner-lightbox.js';
import './attribute/if-partner-online.js';
import './attribute/amateur-list.js';
import './attribute/moderated-amateur-list.js';
import './attribute/class-online.js';

export default featureName;

angular
  .module(featureName, [angularTranslate])
  .config(provideTranslations(featureName))
  .config(provideTranslations('models'))
  .factory('AmateurTile', () => AmateurTile)
  .component(onswAmateurContext, contextComponent);
